import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TicketCategory, TicketStatus } from "@signalist/shared-types";

import { classNames } from "@/utils/classNames";

/** Semantic tokens only (web CLAUDE.md §7); the mapping mirrors the approved mockup's colours. */
const STATUS_CLASSES: Record<TicketStatus, string> = {
	[TicketStatus.OPEN]: "bg-blue-action-200 text-brand-light",
	[TicketStatus.WAITING_ON_US]: "bg-blue-action-200 text-brand-light",
	[TicketStatus.WAITING_ON_CUSTOMER]: "bg-status-warning-light text-status-wrong-person",
	[TicketStatus.RESOLVED]: "bg-status-success-light text-status-success",
	[TicketStatus.CLOSED]: "bg-status-info-light text-status-info",
};

const CATEGORY_CLASSES: Record<TicketCategory, string> = {
	[TicketCategory.BUG]: "bg-status-error-light text-status-error",
	[TicketCategory.QUESTION]: "bg-blue-action-200 text-blue-action",
	[TicketCategory.FEATURE_REQUEST]: "bg-status-progress-light text-status-progress",
	[TicketCategory.BILLING]: "bg-status-warning-light text-status-wrong-person",
	[TicketCategory.DATA_QUALITY]: "bg-status-info-light text-status-info",
	[TicketCategory.TASK]: "bg-status-success-light text-status-success",
};

const PILL =
	"inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-md px-2 text-xs font-medium";

export const TicketStatusPill: FunctionComponent<{ status: TicketStatus }> = ({ status }) => {
	const { t } = useTranslation();

	return (
		<span className={classNames(PILL, STATUS_CLASSES[status])}>
			<span className="h-1.5 w-1.5 rounded-full bg-current" />
			{t(`support.status.${status}`)}
		</span>
	);
};

export const TicketCategoryPill: FunctionComponent<{ category: TicketCategory }> = ({
	category,
}) => {
	const { t } = useTranslation();

	return (
		<span className={classNames(PILL, CATEGORY_CLASSES[category])}>
			{t(`support.category.${category}`)}
		</span>
	);
};
